module.exports = __webpack_public_path__ + "vyhlazeni-vrasek-metodou-derma-k_14_after_tn.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures_tn/plasticka-chirurgie/vyhlazeni-vrasek-metodou-derma-k_14_after_tn.jpg
// module id = 1705
// module chunks = 0